export default {
  state: {},
};
